import { quickBooksConnectionStatus } from '@/lib/constants/quickBooks'

const OUTCOMES = {
  connected: { type: 'success', text: 'QuickBooks connected.' },
  denied: { type: 'warning', text: 'QuickBooks sign-in was not completed.' },
  'state-rejected': { type: 'error', text: 'This sign-in link expired or was already used. Start Connect again.' },
  'company-mismatch': { type: 'error', text: 'That QuickBooks company is not the one recorded for this Business Entity. Nothing was changed.' },
  failed: { type: 'error', text: 'Connecting QuickBooks failed.' }
}

export const connectOutcomeAlert = (query) => {
  const outcome = query && OUTCOMES[query.outcome]
  if (!outcome) return null
  // The link is forgeable, so its message never stands in for the success wording.
  const text = outcome.type === 'success' ? outcome.text : (query.message || outcome.text)
  return { type: outcome.type, text }
}

// QuickBooks lists only active records, so a stored id that has since gone inactive would otherwise show as blank.
export const withStoredOption = (options, storedId, textField) => {
  if (!storedId || options.some(o => o.id === storedId)) {
    return options
  }
  return [...options, { id: storedId, [textField]: `Inactive or missing in QuickBooks (id ${storedId})` }]
}

export const isConnected = (connection) =>
  !!connection && connection.statusName === quickBooksConnectionStatus.Connected

export const connectionStatusAttrs = (statusName) =>
  isConnected({ statusName })
    ? { color: 'green', dark: true }
    : { color: 'grey', dark: true }

export const clientQuickBooksCompany = ({ connections, businessEntityId, configurationError }) => {
  const connection = (connections || []).find(c => c.businessEntityId === businessEntityId)
  const companyName = (connection && connection.companyName) || null

  if (!businessEntityId) {
    return { companyName, connected: false, explanation: 'Choose a Business Entity to map this client to QuickBooks.' }
  }
  if (configurationError) {
    return { companyName, connected: false, explanation: configurationError }
  }
  if (!isConnected(connection)) {
    const entity = (connection && connection.businessEntityName) || 'This Business Entity'
    return {
      companyName,
      connected: false,
      explanation: `${entity}'s QuickBooks company is not connected. Connect it on the QuickBooks Connections page to map this client.`
    }
  }
  return { companyName, connected: true, explanation: null }
}
